export default __webpack_public_path__ + "static/media/Highlord's Cloak of Power.1b1b812c.jpg";